import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useGetPhrAppDepartments = () => {
  const navigate = useNavigate();
  const [allDepartments, setAllDepartments] = useState([]);
  const [isDepartmentLoading, setIsDepartmentLoading] = useState(false);

  const getAllDepartments = useCallback(async () => {
    setIsDepartmentLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(
        `/api/v1/phr-app/departments`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      // Ensure response is an array
      const departments = Array.isArray(res.data) ? res.data : [];
      setAllDepartments(departments);
    } catch (error) {
      console.error(error, "error");
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
        if (error.response?.data?.statusCode === 401) {
          localStorage.removeItem("authToken");
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
      }
      setAllDepartments([]);
    } finally {
      setIsDepartmentLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    getAllDepartments();
  }, [getAllDepartments]);

  return {
    allDepartments,
    isDepartmentLoading,
    getAllDepartments,
  };
};

export default useGetPhrAppDepartments;
